import { GET_CONFIGURATION_DATA, IActionType, SET_SELECTED_TEMPLATE, GET_WA_NUMBER_DATA } from "../actions/failover.action"
import { IFailoverState } from "../models/root.interface";

const initialState: IFailoverState = {
    configurationList: [],
    selectedTemplateId: "",
    waNumberData: {}
}

const failoverReducer = (state: IFailoverState = initialState, action: IActionType): IFailoverState => {
    switch (action.type) {
        case GET_CONFIGURATION_DATA:
            return {
                ...state,
                configurationList: action.payload
            }
        case SET_SELECTED_TEMPLATE:
            return {
                ...state,
                selectedTemplateId: action.payload
            }
        case GET_WA_NUMBER_DATA:
            return {
                ...state,
                waNumberData: action.payload
            }
        default:
            return state;
    }
}

export default failoverReducer;